export enum DocumentStorageTypes {
  WAREHOUSE = 'warehouse',
  CROP = 'crop',
  LIVESTOCK = 'livestock',
  MY_DOCUMENTS = 'my_documents',
}
